import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import { FaTimes } from 'react-icons/fa'
import { Modal, Container, Row, Col, CloseButton} from 'react-bootstrap'
import successful from '../../../../images/bro.svg'

const PaymentModal = (props) => {
  const navigate= useNavigate();
    return (
        <div>
           
          <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered className='bg-white align-items-center justify-content-center text-center'
        >
          
          <Modal.Body className='align-items-center justify-content-center text-center'>
          <Container className='d-flex flex-column gap-3 p-5 align-items-center justify-content-center text-center '>
              <img src={successful} alt='successful'/>
              <div className='gap-1 mt-3 mb-3'>
              <h2 className='payment'>Payment Successful!!!</h2>
<p style={{color:'#99A1A1',
fontSize: '14px',
fontFamily: 'Lora',
fontWeight: '600'}}> Kindly check your email for payment receipt</p>
</div>
<div className='mb-3'>
<button onClick={() => navigate('/user-booking')}  style={{height: '48px',
width: '200px',

borderRadius: '8px',

backgroundColor: '#008080', border:'none', color:'#fff'}}>Go back</button>
</div>

<div >
    <p onClick={() => navigate('/contact')} className='refund' style={{fontSize:'16px'}}> Contact us for Help</p>
            <p onClick={() => navigate('/profile')} style={{fontSize:'16px'}}className='forgot-password'>Go to Profile</p>
</div>
    
              
            </Container>
          </Modal.Body>
          
           </Modal>
          
        </div>
      )
  
}

export default PaymentModal
